import { cn } from "../../lib/cn";
import { confidenceChipClass, confidenceLabel } from "./utils";

export function ConfidenceChip({ level, testId }: { readonly level: string; readonly testId?: string }) {
  return (
    <span
      data-testid={testId}
      className={cn("inline-block shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold", confidenceChipClass(level))}
    >
      {confidenceLabel(level)}
    </span>
  );
}
